angular.module('picmonicng').controller('MyNotesController', [
  '$scope',
  'Notes',
  '$filter',
  '$window',
  '$timeout',
  '$stateParams',
  'ngBowser',
  function ($scope, Notes, $filter, $window, $timeout, $stateParams, ngBowser) {
    $scope.isSafari = ngBowser.browser.name === 'Safari';
    $scope.printMode = false;
    $scope.loading = true;
    $scope.notes = [];
    $scope.masterNotesList = [];
    $scope.selectedNotes = [];
    $scope.pdfItems = {};
    $scope.school_id = $stateParams.school_id ? $stateParams.school_id : '';
    $scope.picmonic_id = $stateParams.picmonic_id ? $stateParams.picmonic_id : '';
    $scope.sortOptions = {
      '-updated_at': 'Last Edit',
      '-created_at': 'Date Created',
      '-note_updated_at': 'Date Modified',
      '-note_created_at': 'Date Created',
      'name': 'Picmonic A-Z',
      '-name': 'Picmonic Z-A',
      'first_name': 'Author A-Z',
      '-first_name': 'Author Z-A',
      'root_category_name': 'Course A-Z',
      '-root_category_name': 'Course Z-A',
    };

    $scope.setSortOrder = function (sortOrder) {
      send_ga('event', 'Notes', 'Sorted ' + $scope.sortOptions[sortOrder]);
      $scope.selectedSort = sortOrder;
    };
    $scope.setSortOrder('-updated_at');

    Notes.query().$promise.then(function (data) {
      $scope.notes = data;
      $scope.masterNotesList = data;
      $scope.selectedNotes.all = true;
      $scope.toggleCheckboxes('all');
      $scope.loading = false;
      $scope.$emit('endInteraction');
    });

    $scope.toggleCheckboxes = function (type) {
      $scope.queryStringParameter = '';
      $scope.printMode = false;

      if (type == 'all') {
        if ($scope.selectedNotes.all) {
          $scope.notes = $scope.masterNotesList;
          angular.forEach($scope.notes, function (value, key) {
            value.selected = true;
          });
        } else {
          angular.forEach($scope.notes, function (value, key) {
            value.selected = false;
          });
        }
      }
    };

    $scope.togglePrintMode = function () {
      $scope.printMode = !$scope.printMode;
      if ($scope.selectedNotes.length > 0) {
        $window.print();
      }
    };

    $scope.downloadPDF = function () {
      $scope.queryStringParameter = '';
      $scope.pdfItems = $filter('orderBy')($filter('filter')($scope.notes, { selected: 'true' }), $scope.selectedSort);

      angular.forEach($scope.pdfItems, function (value, key) {
        $scope.queryStringParameter += String(value.id);
        if (key + 1 != $scope.pdfItems.length) {
          $scope.queryStringParameter += '|';
        }
      });
      if ($stateParams.school_id && $stateParams.picmonic_id && $scope.queryStringParameter != '') {
        $window.open(
          '/school/' + $scope.school_id + '/notes/' + $scope.picmonic_id + '/download/' + $scope.queryStringParameter
        );
      } else if ($scope.queryStringParameter != '') {
        $window.open('/notes/' + $scope.queryStringParameter + '/download');
      }
    };

    $scope.selectedNotesLength = function () {
      $scope.selectedNotes.length = $filter('orderBy')(
        $filter('filter')($scope.notes, { selected: 'true' }),
        $scope.selectedSort
      ).length;
    };
  },
]);
